(function () {
  'use strict';

  function initTabs(section) {
    var tabGroups = section.querySelectorAll('[role="tablist"]');
    if (!tabGroups.length) return;
    var panels = section.querySelectorAll('.oddit-section-hair-match__panel[data-panel-index]');

    function setActiveIndex(index) {
      tabGroups.forEach(function (group) {
        var tabs = group.querySelectorAll('.oddit-section-hair-match__tab');
        tabs.forEach(function (tab) {
          var tabIndex = Number(tab.getAttribute('data-tab-index'));
          var isActive = tabIndex === index;
          tab.classList.toggle('oddit-section-hair-match__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      });

      panels.forEach(function (panel) {
        var panelIndex = Number(panel.getAttribute('data-panel-index'));
        var isActive = panelIndex === index;
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.oddit-section-hair-match__tab');
      if (!btn || !section.contains(btn)) return;
      var idx = Number(btn.getAttribute('data-tab-index'));
      if (Number.isNaN(idx)) return;
      setActiveIndex(idx);
    });
  }

  function initCompare(section) {
    var compare = section.querySelector('.oddit-section-hair-match__compare');
    var handle = section.querySelector('.oddit-section-hair-match__handle');
    if (!compare || !handle) return;

    function setPositionFromClientX(clientX) {
      var rect = compare.getBoundingClientRect();
      if (rect.width === 0) return;
      var pct = ((clientX - rect.left) / rect.width) * 100;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      compare.style.setProperty('--position', pct + '%');
      handle.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    function getPosition() {
      var raw = compare.style.getPropertyValue('--position');
      var val = parseFloat(raw);
      return isNaN(val) ? 50 : val;
    }

    function setPosition(pct) {
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      compare.style.setProperty('--position', pct + '%');
      handle.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    function onPointerMove(e) {
      setPositionFromClientX(e.clientX);
    }

    function onPointerUp(e) {
      handle.removeEventListener('pointermove', onPointerMove);
      handle.removeEventListener('pointerup', onPointerUp);
      handle.removeEventListener('pointercancel', onPointerUp);
      if (e && typeof e.pointerId === 'number') {
        try { handle.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }

    handle.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      try { handle.setPointerCapture(e.pointerId); } catch (err) {}
      handle.addEventListener('pointermove', onPointerMove);
      handle.addEventListener('pointerup', onPointerUp);
      handle.addEventListener('pointercancel', onPointerUp);
    });

    compare.addEventListener('pointerdown', function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      var tabEl = e.target.closest && e.target.closest('.oddit-section-hair-match__tab');
      if (tabEl) return;
      setPositionFromClientX(e.clientX);
    });

    handle.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 5;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
        setPosition(getPosition() - step);
        e.preventDefault();
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
        setPosition(getPosition() + step);
        e.preventDefault();
      } else if (e.key === 'Home') {
        setPosition(0);
        e.preventDefault();
      } else if (e.key === 'End') {
        setPosition(100);
        e.preventDefault();
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.odditHairMatchInit === 'true') return;
    section.dataset.odditHairMatchInit = 'true';
    initTabs(section);
    initCompare(section);
  }

  document.querySelectorAll('.oddit-section-hair-match').forEach(initSection);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelector) return;
      var section = e.target.querySelector('.oddit-section-hair-match');
      if (section) initSection(section);
    });
  }
})();
